import React, {useEffect, useState} from "react";
import {boldTextStyles, regularErrorStyle, regularTextStyles, subHeadingStyles} from "../Style";
import {Form, Row} from "react-bootstrap";
import NavigateCarInsurance from "./NavigateCarInsurance";
import Cookies from "js-cookie";
import {useSearchParams} from "react-router-dom";
import ContinueOfflinePopupTFAF1 from "./ContinueOfflinePopupTFAF1";
import TooltipTFAF from "./common/TooltipTFAF";
import moment from "moment/moment";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const DriverDetails = props => {
  const [errors, setErrors] = useState({});
  const [continueOfflinePopupShow, setContinueOfflinePopupShow] = useState(false);
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  // let url = 'http://localhost:8080/edge';
  const currentYear = new Date().getFullYear();
  const lastThreeYears = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
  const [searchParams] = useSearchParams();
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [verificationFailedStep, setVerificationFailedStep] = useState('');
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
      ? 'carAutosureEvent'
      : window.location.href.includes('quashed')
          ? 'carQuashedEvent'
          : window.location.href.includes('better')
              ? 'carBetterEvent'
              : window.location.href.includes('simplify')
                  ? 'carSimplifyEvent'
                  : '';

  useEffect((e) => {
    if (verificationFailedStep === 'handleNextButtonClick') {
      handleNextButtonClick();
    }
  }, [props.inputValues.isRecaptchaV2Verified]);

  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Page View',
        'virtualUrl': `${baseUrl}/vehicle/step2`,
        'pageTitle': 'Driver',
      });
    window.scrollTo(0, 0);
  }, []);

  const handleAddDriver = () => {
    if (props.inputValues.driverLength < 5) {
      props.updateDriver(`driver${props.inputValues.driverLength + 1}.firstName`, '');
      props.updateDriver(`driver${props.inputValues.driverLength + 1}.lastName`, '');
      props.updateDriver(`driver${props.inputValues.driverLength + 1}.dateOfBirth`, '');
      props.updateDriver(`driver${props.inputValues.driverLength + 1}.incidentCount`, '');
      props.handleChangeValue('driverLength', props.inputValues.driverLength + 1);
    }
  };

  const handleRemoveDriver = (index) => {

    if (props.inputValues.driverLength > 1) {
      props.updateDriver(`driver${props.inputValues.driverLength}.firstName`, '');
      props.updateDriver(`driver${props.inputValues.driverLength}.lastName`, '');
      props.updateDriver(`driver${props.inputValues.driverLength}.dateOfBirth`, '');
      props.updateDriver(`driver${props.inputValues.driverLength + 1}.incidentCount`, '');
      props.handleChangeValue('driverLength', props.inputValues.driverLength - 1);
      for (let i = 0; i < 5; i++) {
        props.updateDriver(`driver${props.inputValues.driverLength}.incidentList.incidents${i + 1}.claimCode`, '');
        props.updateDriver(`driver${props.inputValues.driverLength}.incidentList.incidents${i + 1}.claimMonth`, '');
        props.updateDriver(`driver${props.inputValues.driverLength}.incidentList.incidents${i + 1}.claimYear`, '');
      }
    }
  };
  const handleDateChange = (e) => {
    let inputVal = e.target.value;
    // Check if the input length is 2 or 5 and the last character is not "/"
    if ((inputVal.length === 2 || inputVal.length === 5) && inputVal.charAt(inputVal.length - 1) !== '/') {
      // Automatically append "/"
      inputVal += '/';
      e.target.value = inputVal;
    }
    props.updateDriver(e.target.name, inputVal);
    // Update the input value
    props.handleChange(e);
  };
  const handleIncidentCount = (e, driverIndex) => {
    // Call the props.handleUpdateJson to update the JSON data
    //props.handleUpdateJson(e);
    props.updateDriver(`driver${driverIndex}.incidentCount`, e.target.value);
    // Get the selected value
    const selectedIncidents = e.target.value;
    // Perform additional logic based on the selected value
    if (selectedIncidents !== "5+") {
      const incidentsArray = Array.from({length: parseInt(selectedIncidents, 10)}, () => ({}));
      for (let i = incidentsArray.length; i < 5; i++) {
        props.updateDriver(`driver${driverIndex}.incidentList.incidents${i + 1}.claimCode`, '');
        props.updateDriver(`driver${driverIndex}.incidentList.incidents${i + 1}.claimMonth`, '');
        props.updateDriver(`driver${driverIndex}.incidentList.incidents${i + 1}.claimYear`, '');
      }
    }
  };
  const calculateAge = (dateEntered) => {
    let bday = moment(dateEntered, 'DD/MM/YYYY');
    if (!bday.isValid()) {
      return NaN;
    }
    let today = moment();
    let age = today.diff(bday, 'years');
    return age;
  }
  const renderIncidentsData = (selectedIncidents, driverIndex) => {
    if (selectedIncidents === "5+") {
      // Display popup message for 5+ incidents
      return (
        <div style={{color: "red", paddingTop: "10px"}}>
          Sorry, we’re unable to offer you car insurance based on this information.
        </div>
      );
    } else {
      const incidentsArray = Array.from({length: parseInt(selectedIncidents, 5)}, () => ({}));
      return (
        <>
          {/*<div>{props.inputValues.driverList[driver].incidents}</div>*/}
          {incidentsArray.map((item, index) => (
            <div className="column-on-mobile lg-row-flex" key={index}>
              <div style={{
                paddingBottom: "10px", width: '100%',
                maxWidth: '300px',
              }}>
                <Form.Group controlId={`formTransmissionType${index}`} className="form-group">
                  <Form.Label style={{paddingBottom: "10px"}}><span
                    style={regularTextStyles}>Type of issue</span></Form.Label>
                  <Form.Select
                    className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    style={{
                      border: '1px #E5E7EB solid',
                      boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                      borderRadius: 6,
                      width: '100%',
                      maxWidth: '300px',
                      fontSize: '1rem', //16px
                      fontFamily: 'Lato',
                      fontWeight: '400',
                    }}
                    defaultValue={getIncidentData(driverIndex, index, 'claimCode')}
                    required
                    name={`driver${driverIndex}.incidentList.incidents${index + 1}.claimCode`}
                    onChange={props.handleUpdateJson}
                  >
                    <option value="" disabled>Please select</option>
                    {/*<option value="WINDSCREEN" >Windscreen claim</option>*/}
                    <option value="FAULT_EXCESS">You were at fault and an excess was payable</option>
                    {/*<option value="NATURAL">Natural Disaster</option>*/}
                    <option value="CLAIM_EXCESS">Any other claim where an excess was payable (theft etc.)</option>
                    <option value="CLAIM_NO_EXCESS">Any claims where no excess was payable</option>
                    <option value="LICENCE_SUS">Licence suspension, disqualification or cancellation</option>
                  </Form.Select>
                </Form.Group>
                {errors[`driver${driverIndex}.incidentList.incidents${index + 1}.claimCode`] && (
                  <div
                    style={regularErrorStyle}>{errors[`driver${driverIndex}.incidentList.incidents${index + 1}.claimCode`]}</div>
                )}
              </div>
              <div style={{
                paddingBottom: "10px", width: '100%',
                maxWidth: '300px',
              }}>
                <Form.Group controlId={`formMonth${index}`} className="form-group">
                  <Form.Label style={{paddingBottom: "10px"}}><span
                    style={regularTextStyles}>Month</span></Form.Label>
                  <Form.Select
                    className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    style={{
                      border: '1px #E5E7EB solid',
                      boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                      borderRadius: 6,
                      width: '100%',
                      maxWidth: '300px',
                      fontSize: '1rem', //16px
                      fontFamily: 'Lato',
                      fontWeight: '400',
                    }}
                    defaultValue={getIncidentData(driverIndex, index, 'claimMonth')}
                    required
                    // name={`month${index}`}
                    name={`driver${driverIndex}.incidentList.incidents${index + 1}.claimMonth`}
                    onChange={props.handleUpdateJson}
                  >
                    <option value="" disabled>Please select</option>
                    {months.map((month, monthIndex) => (
                      <option key={monthIndex} value={monthIndex + 1}>{month}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {errors[`driver${driverIndex}.incidentList.incidents${index + 1}.claimMonth`] && (
                  <div
                    style={regularErrorStyle}>{errors[`driver${driverIndex}.incidentList.incidents${index + 1}.claimMonth`]}</div>
                )}
              </div>
              <div style={{
                paddingBottom: "10px", width: '100%',
                maxWidth: '300px',
              }}>
                <Form.Group controlId={`formYear${index}`} className="form-group">
                  <Form.Label style={{paddingBottom: "10px"}}><span
                    style={regularTextStyles}>Year</span></Form.Label>
                  <Form.Select
                    className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    style={{
                      border: '1px #E5E7EB solid',
                      boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                      borderRadius: 6,
                      width: '100%',
                      maxWidth: '300px',
                      fontSize: '1rem', //16px
                      fontFamily: 'Lato',
                      fontWeight: '400',
                    }}
                    defaultValue={getIncidentData(driverIndex, index, 'claimYear')}
                    required
                    // name={`year${index}`}
                    name={`driver${driverIndex}.incidentList.incidents${index + 1}.claimYear`}
                    onChange={props.handleUpdateJson}
                  >
                    <option value="" disabled>Please select</option>
                    {lastThreeYears.map((year, yearIndex) => (
                      <option key={yearIndex} value={year}>{year}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {errors[`driver${driverIndex}.incidentList.incidents${index + 1}.claimYear`] && (
                  <div
                    style={regularErrorStyle}>{errors[`driver${driverIndex}.incidentList.incidents${index + 1}.claimYear`]}</div>
                )}
              </div>
            </div>
          ))}
          {errors[`driver${driverIndex}.incidentError`] &&
            <div style={regularErrorStyle}>{errors[`driver${driverIndex}.incidentError`]}</div>}
        </>
      );
    }
  };

  const steps = [
    {name: 'Step 1', status: 'complete', desc: 'Car'}, {
      name: 'Step 2',
      status: 'current',
      desc: 'Driver'
    }, {name: 'Step 3', status: 'upcoming', desc: 'Quote'}, {
      name: 'Step 4',
      status: 'upcoming',
      desc: 'Policyholder'
    }, {name: 'Step 5', status: 'upcoming', desc: 'Payment'},];

  const handleNextButtonClick = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setErrors({});
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': `${eventName}`,
          'category': 'Submit',
          'status': 'Fail',
          'virtualUrl': `${baseUrl}/vehicle/step2`,
          'pageTitle': 'Driver',
        });
      // Scroll to the first error
      const firstErrorKey = Object.keys(newErrors)[0];
      const errorElement = document.getElementsByName(firstErrorKey)[0];
      if (errorElement) {
        errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
      setErrors(newErrors);
    } else if (!isSubmitting) {
      setIsSubmitting(true);
      let date = new Date(); // Or the date you'd like converted.
      let isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
      let startDate = isoDateTime.slice(0, 10);
      date.setFullYear(date.getFullYear() + 1);
      isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
      let expiryDate = isoDateTime.slice(0, 10);
      let jwt = Cookies.get('jwt-token');
      // Convert driverList object into an array of drivers
      const driverArray = Object.keys(props.inputValues.driverList).map(key => props.inputValues.driverList[key]);

      const additionalDriverArray = [];

      driverArray.map((driver, idx) => {
        if (idx !== 0 && driver.firstName !== '') {
          let incidentList = [];
          for (let i = 1; i < 5; i++) {
            if (driver.incidentList["incidents" + i].claimCode !== '') {
              incidentList.push(driver.incidentList["incidents" + i]);
            }
          }
          let additionalDriver = {
            "dateOfBirth": driver.dateOfBirth.split("/").reverse().join("-"),
            "claimHistory": incidentList
          };
          additionalDriverArray.push(additionalDriver);
        }
      })

      // Map through driverArray to extract required fields
      const formattedDriverList = driverArray.map(driver => ({

        // if(driver.)

        givenName: driver.firstName,
        surname: driver.lastName,
        dateOfBirth: driver.dateOfBirth,
        issue1: driver.incidentList.incidents1.claimCode,
        issue2: driver.incidentList.incidents2.claimCode,
        issue3: driver.incidentList.incidents3.claimCode,
        issue4: driver.incidentList.incidents4.claimCode,
        month1: driver.incidentList.incidents1.claimMonth,
        month2: driver.incidentList.incidents2.claimMonth,
        month3: driver.incidentList.incidents3.claimMonth,
        month4: driver.incidentList.incidents4.claimMonth,
        year1: driver.incidentList.incidents1.claimYear,
        year2: driver.incidentList.incidents2.claimYear,
        year3: driver.incidentList.incidents3.claimYear,
        year4: driver.incidentList.incidents4.claimYear,
        incidentCount: driver.incidentCount,
        type: driver.type,
      }));

      let mainDriverIncidents = [];
      let driver1 = props.inputValues.driverList.driver1;
      for (let i = 1; i < 5; i++) {

        if (driver1.incidentList["incidents" + i].claimCode !== '') {
          mainDriverIncidents.push(driver1.incidentList["incidents" + i]);
        }
      }
      if (!executeRecaptcha) {
        console.log('reCAPTCHA is not ready');
        return;
      }
      let token = await executeRecaptcha('submit');
      if (props.inputValues.isRecaptchaV2Verified) {
        token = "AUTHENTICATED_V2"
      }
      if (!jwt) {
        window.location.href = `/error-occurred`;
      }
      fetch(url + '/vero/quote/create', {

        method: "POST",
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${jwt}`
        }),
        body: JSON.stringify(
          {
            "attributes": {
              "coverages": [
                {
                  "compensations": [
                    {
                      "appliedIndicator": true,
                      "compensationSubType": "AgreedValue",
                      "compensationType": "SumInsured",
                      "value": props.inputValues.vehicleValue
                    },
                    {
                      "appliedIndicator": true,
                      "compensationSubType": "MarketValue",
                      "compensationType": "SumInsured",
                      "value": props.inputValues.vehicleValue
                    },
                    {
                      "appliedIndicator": false,
                      "compensationSubType": "WindscreenExcessWaiver",
                      "compensationType": "CoverType"
                    },
                    {
                      "appliedIndicator": true,
                      "code": "HIRE_CAR_NOT_TAKEN",
                      "compensationSubType": "HireCar",
                      "compensationType": "CoverType"
                    },
                    {
                      "appliedIndicator": true,
                      "code": "NOT_ELIGIBLE",
                      "compensationSubType": "LifetimeNewForOld",
                      "compensationType": "CoverType"
                    },
                    {
                      "appliedIndicator": false,
                      "compensationSubType": "RoadsideAssist",
                      "compensationType": "CoverType"
                    }
                  ],
                  "policyCoverType": "COMPREHENSIVE",
                  "risk": {
                    "addressDetails": {
                      "addressId": props.inputValues.riskAddressId,
                      "addressInBrokenDownForm": {
                        "streetName": props.inputValues.riskStreetName,
                        "streetNumber": props.inputValues.riskStreetNumber,
                        "streetType": props.inputValues.riskStreetType,
                        "buildingName": props.inputValues.riskBuildingName,
                        "levelNumber": props.inputValues.riskLevelNumber,
                        "levelType": props.inputValues.riskLevelType,
                        "streetSuffixCode": props.inputValues.riskStreetSuffixCode,
                        "unitNumber": props.inputValues.riskUnitNumber,
                        "unitType": props.inputValues.riskUnitType,
                      },
                      "addressInFreeForm": {
                        "addressLine1": props.inputValues.riskAddressLine1,
                        "addressLine2": props.inputValues.riskAddressLine2
                      },
                      "postcode": props.inputValues.riskPostcode,
                      "signature": props.inputValues.riskSignature,
                      "suburb": props.inputValues.riskSuburb
                    },
                    "vehicleRisk": {
                      "accessoriesIndicator": false,
                      "damagedIndicator": false,
                      "financeIndicator": props.inputValues.isFinanced === "YES",
                      "additionalDrivers": additionalDriverArray,
                      "mainDriver": {
                        "claimHistory": mainDriverIncidents,
                        "dateOfBirth": props.inputValues.driverList.driver1.dateOfBirth.split("/").reverse().join("-")
                      },
                      "modificationIndicator": false,
                      "vehicleKey": props.inputValues.vehicleKey,
                      "vehicleUsageType": "PRIVATE"
                    }
                  },
                  "voluntaryExcess": props.inputValues.excess
                }
              ],
              "quoteRequestDetails": {
                "frequency": props.inputValues.paymentFrequency,
                "policyExpiryDate": expiryDate,
                "policyInceptionDate": startDate,
                "previousInsurer": "NONE"
              }
            },
            "type": "string",
            id: props.inputValues.id,
            drivers: formattedDriverList,
            "recaptchaResponse": token
          }
          // {"attributes":{"coverages":[{"compensations":[{"appliedIndicator":true,"compensationSubType":"AgreedValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":true,"compensationSubType":"MarketValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":false,"compensationSubType":"WindscreenExcessWaiver","compensationType":"CoverType"},{"appliedIndicator":true,"code":"HIRE_CAR_NOT_TAKEN","compensationSubType":"HireCar","compensationType":"CoverType"},{"appliedIndicator":true,"code":"NOT_ELIGIBLE","compensationSubType":"LifetimeNewForOld","compensationType":"CoverType"},{"appliedIndicator":false,"compensationSubType":"RoadsideAssist","compensationType":"CoverType"}],"policyCoverType":"COMPREHENSIVE","risk":{"addressDetails":{"addressId":"lUehd0gPgdL7FOGHQupuXBROntGLNm6wj66a0SsavQaXsKAYqpnZV9askzSBR8TE","addressInBrokenDownForm":{"streetName":"MANUKAU","streetNumber":"100","streetType":"RD"},"addressInFreeForm":{"addressLine1":"100 Manukau Rd"},"postcode":"1023","signature":"4TTiwKhzTf8t/twBDXACcZ/MnbZ3SszWCAQgu27b6xg=","suburb":"EPSOM"},"vehicleRisk":{"accessoriesIndicator":false,"additionalDrivers":[],"damagedIndicator":false,"financeIndicator":false,"mainDriver":{"claimHistory":[],"dateOfBirth":"1990-11-11"},"modificationIndicator":false,"vehicleKey":"0ATnSOMvvQ/q8WHUdGGSmQ==","vehicleUsageType":"PRIVATE"}},"voluntaryExcess":300}],"quoteRequestDetails":{"frequency":"FORTNIGHTLY","policyExpiryDate":"2025-03-27","policyInceptionDate":"2024-03-27","previousInsurer":"NONE"}},"type":"string"}

        )
      })
        .then(response => {
          if (response.status === 428) {
            // Show fallback captcha for 428 status
            console.log('Primary reCAPTCHA failed for vehicle lookup, showing fallback captcha');
            setIsSubmitting(false);
            props.handleChangeValue("showRecaptchaPopup", true);
            setVerificationFailedStep("handleNextButtonClick");
            return;
          }
          setIsSubmitting(false);
          if (response.ok) {
            if (response.status === 204) {
              props.nextStep();

            } else {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event': `${eventName}`,
                  'category': 'Submit',
                  'status': 'Success',
                  'virtualUrl': `${baseUrl}/vehicle/step2`,
                  'pageTitle': 'Driver',
                });

              return response.json().then(data => {
                // console.log("JSON.stringify(data)", JSON.stringify(data));
                props.handleChangeValue('responseJson', JSON.stringify(data));
                props.nextStep();
              });
            }
          } else {
            console.log('Response not ok:', response.status, response.statusText);
            // Parse the error response to check for specific error messages
            return response.json().then(errorData => {
              console.log('Error response data:', errorData);

              // Check if the error message contains "The age of the vehicle"
              const errorMessage = JSON.stringify(errorData.message || '');
              console.log('Error message:', errorMessage);

              if (errorMessage.includes('The age of the vehicle')) {
                console.log('Redirecting to age-of-vehicle-error page');
                window.location.href = `/age-of-vehicle-error`;
              } else {
                window.location.href = `/error-occurred`;
              }
            }).catch(parseError => {
              console.log('Error parsing response:', parseError);
              window.location.href = `/error-occurred`;
            });
          }
        })
        .catch(error => {
          setIsSubmitting(false);
          console.log('Error:', error);
          window.location.href = `/error-occurred`;
        });
    }
  }

  const findFormErrors = () => {
    const newErrors = {}
    const nameRegex = /^[A-Za-z\s\-]+$/; // Regex to allow alphabets, space, and hyphen only
    if (props.inputValues.isCriminalRecord === null) {
      newErrors.isCriminalRecord = "Please select ‘Yes’ or ‘No’"
    }
    const driverArray = Object.keys(props.inputValues.driverList).map(key => props.inputValues.driverList[key]);
    const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-11
    const currentYear = new Date().getFullYear();
    for (let index = 0; index < props.inputValues.driverLength; index++) {
      const arrayElement = driverArray[index];
      if (!arrayElement.firstName) {
        newErrors[`driver${index + 1}.firstName`] = "Please enter first name";
      } else if (!nameRegex.test(arrayElement.firstName)) {
        newErrors[`driver${index + 1}.firstName`] = "Only letters, -, ' and space are allowed.";
      }
      if (!arrayElement.lastName) {
        newErrors[`driver${index + 1}.lastName`] = "Please enter last name";
      } else if (!nameRegex.test(arrayElement.lastName)) {
        newErrors[`driver${index + 1}.lastName`] = "Only letters, -, ' and space are allowed.";
      }
      if (!arrayElement.dateOfBirth) {
        newErrors[`driver${index + 1}.dateOfBirth`] = "Please enter date of birth";
      } else {
        let dob = arrayElement.dateOfBirth;
        const array = dob.split("/");
        if (array.length === 3) {
          let day = ('0' + array[0]).slice(-2);
          let month = ('0' + array[1]).slice(-2);
          dob = day + '/' + month + '/' + array[2];
          //props.handleChangeValue('dateOfBirth', dob);
        }
        let isValid = moment(arrayElement.dateOfBirth, 'DD/MM/YYYY', true);
        if (!isValid.isValid()) {
          newErrors[`driver${index + 1}.dateOfBirth`] = 'Invalid date. Please enter date in format dd/mm/yyyy.'
        } else {
          let dobDate = moment(dob, 'DD/MM/YYYY', true);
          let year = new Date().getFullYear();
          if (dobDate.year() < 1900 || dobDate.year() > year) {
            newErrors[`driver${index + 1}.dateOfBirth`] = 'Date of birth is invalid.'
          } else {
            let age = calculateAge(arrayElement.dateOfBirth);
            if (age < 16) {
              newErrors[`driver${index + 1}.dateOfBirth`] = 'Age should be more than 16 years old'
            } else if (age > 115) {
              newErrors[`driver${index + 1}.dateOfBirth`] = 'Age should be less than 115 years.'
            }
          }
        }

      }
      if (!arrayElement.incidentCount) {
        newErrors[`driver${index + 1}.incidentCount`] = "Please select number of incidents";
      }
      // Incident validation
      let faultExcessCount = 0;
      let claimExcessCount = 0;
      let claimNoExcessCount = 0;
      let licenceSuspensionCount = 0;
      for (let i = 0; i <= arrayElement.incidentCount; i++) {
        const incident = arrayElement.incidentList[`incidents${i}`];
        if (incident) {
          const {claimCode, claimMonth, claimYear} = incident;

          // Count the number of FAULT_EXCESS incidents
          if (claimCode === "FAULT_EXCESS") {
            faultExcessCount++;
          }
          if (claimCode === "CLAIM_EXCESS") {
            claimNoExcessCount++;
          }
          if (claimCode === "CLAIM_NO_EXCESS") {
            claimExcessCount++;
          }
          if (claimCode === "LICENCE_SUS") {
            licenceSuspensionCount++;
          }

          if (!claimCode || claimCode === '') {
            newErrors[`driver${index + 1}.incidentList.incidents${i}.claimCode`] = 'Please select type of issue';
          }
          if (!claimMonth || claimMonth === '') {
            newErrors[`driver${index + 1}.incidentList.incidents${i}.claimMonth`] = 'Please select month';
          }
          if (!claimYear || claimYear === '') {
            newErrors[`driver${index + 1}.incidentList.incidents${i}.claimYear`] = 'Please select year';
          }
          if (claimYear && claimMonth) {
            if (parseInt(claimYear, 10) > currentYear || (parseInt(claimYear, 10) === currentYear && parseInt(claimMonth, 10) > currentMonth)) {
              newErrors[`driver${index + 1}.incidentList.incidents${i}.claimMonth`] = 'Future month cannot be selected';
            }
          }
        }
      }
      if (faultExcessCount > 3 || claimExcessCount > 3 || claimNoExcessCount > 3 || licenceSuspensionCount > 1 || ((faultExcessCount + claimExcessCount + claimNoExcessCount) > 4)) {
        newErrors['driver' + (index + 1) + '.incidentError'] = 'Sorry, we’re unable to offer you car insurance based on this information.';
      }
    }
    return newErrors;
  }
  const getAttributeValue = (idx, attribute) => {
    let attributeValue = '';
    const driverArray = Object.keys(props.inputValues.driverList).map(key => props.inputValues.driverList[key]);
    driverArray.map((driver, index) => {
      if (index === idx) {
        if (attribute === 'firstName') {
          attributeValue = driver.firstName;
        }
        if (attribute === 'lastName') {
          attributeValue = driver.lastName;
        }
        if (attribute === 'dateOfBirth') {
          attributeValue = driver.dateOfBirth;
        }
        if (attribute === 'incidentCount') {
          attributeValue = driver.incidentCount;
        }
      }
    });
    return attributeValue;
  }
  const getIncidentData = (driverIndex, incidentIndex, attribute) => {
    let attributeValue = '';
    const driverArray = Object.keys(props.inputValues.driverList).map(key => props.inputValues.driverList[key]);
    driverArray.map((driver, index) => {
      if (index === driverIndex - 1) {

        const incidentArray = Object.keys(driver.incidentList).map(key => driver.incidentList[key]);
        incidentArray.map((incident, idx) => {
          if (idx === incidentIndex) {
            if (attribute === 'claimCode') {
              attributeValue = incident.claimCode;
            }
            if (attribute === 'claimMonth') {
              attributeValue = incident.claimMonth;
            }
            if (attribute === 'claimYear') {
              attributeValue = incident.claimYear;
            }
          }
        });
      }
    });
    return attributeValue;
  }
  return <>
    <br/><br/>
    <Row className="justify-content-center">
      <NavigateCarInsurance steps={steps}/>
    </Row>
    <div className="lg-car-padding sm-car-padding">
      <div style={{paddingTop: "20px"}}>
        <div style={{paddingBottom: "50px"}}>
                <span style={subHeadingStyles}>
                    Driver
                </span>
        </div>
        <div style={{paddingBottom: "20px"}}>
                    <span style={boldTextStyles}>
                    Main driver
                    </span>
          <TooltipTFAF
            title="The 'main driver' is the person who uses your car most of the time. You can also add additional drivers below.">
            <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
          </TooltipTFAF>
        </div>
        {Array.from(Array(props.inputValues.driverLength), (driver, index) => <div key={index}>
          {index !== 0 &&
            <div style={{paddingTop: "30px"}}><span style={boldTextStyles}>Additional driver {index}</span></div>}

          <div className="column-on-mobile lg-row-flex">
            <div style={{
              width: '100%',
              maxWidth: '300px',
            }}>
              <Form.Group controlId={`formJointFirstName${index}`} className="form-group">
                <Form.Label style={{paddingBottom: "10px"}}><span style={regularTextStyles}>First Name</span>
                </Form.Label>
                <input
                  type="text"
                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Enter first name"
                  style={{
                    border: '1px #E5E7EB solid',
                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                    borderRadius: 6,
                    outline: 'none',
                    fontSize: '1rem', //16px
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    lineHeight: 'inherit',
                    width: '100%',
                    maxWidth: '300px',
                    height: '40px',
                    marginRight: '10px',
                    background: 'transparent',
                  }}
                  defaultValue={getAttributeValue(index, 'firstName')}
                  name={`driver${index + 1}.firstName`}
                  onChange={props.handleUpdateJson}
                  required
                />
                {errors[`driver${index + 1}.firstName`] &&
                  <div style={regularErrorStyle}>{errors[`driver${index + 1}.firstName`]}</div>}
              </Form.Group></div>
            <div style={{
              width: '100%',
              maxWidth: '300px',
            }}>
              <Form.Group controlId="formJointLastName" className="form-group">
                <Form.Label className="label" style={{paddingBottom: "10px"}}><span
                  style={regularTextStyles}>Last Name</span></Form.Label>
                <input
                  type="text"
                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Enter last name"
                  style={{
                    border: '1px #E5E7EB solid',
                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                    borderRadius: 6,
                    outline: 'none',
                    fontSize: '1rem', //16px
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    lineHeight: 'inherit',
                    width: '100%',
                    maxWidth: '300px',
                    height: '40px',
                    marginRight: '10px',
                    background: 'transparent',
                  }}
                  defaultValue={getAttributeValue(index, 'lastName')}
                  name={`driver${index + 1}.lastName`}
                  onChange={props.handleUpdateJson}
                  required
                />
                {errors[`driver${index + 1}.lastName`] &&
                  <div style={regularErrorStyle}>{errors[`driver${index + 1}.lastName`]}</div>}
              </Form.Group></div>
            <div style={{
              width: '100%',
              maxWidth: '300px',
            }}>
              <Form.Group controlId={`formJointDateOfBirth${index}`} className="form-group">
                <Form.Label style={{paddingBottom: "10px"}}><span
                  style={regularTextStyles}>Date of Birth</span></Form.Label>
                <input
                  type="text"
                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder='dd/mm/yyyy'
                  style={{
                    border: '1px #E5E7EB solid',
                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                    borderRadius: 6,
                    outline: 'none',
                    fontSize: '1rem', //16px
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    lineHeight: 'inherit',
                    width: '100%',
                    maxWidth: '300px',
                    height: '40px',
                    marginRight: '10px',
                    background: 'transparent',
                  }}
                  defaultValue={getAttributeValue(index, 'dateOfBirth')}
                  name={`driver${index + 1}.dateOfBirth`}
                  onChange={handleDateChange}
                />
                {errors[`driver${index + 1}.dateOfBirth`] &&
                  <div style={regularErrorStyle}>{errors[`driver${index + 1}.dateOfBirth`]}</div>}
              </Form.Group>
            </div>
          </div>

          <br/>
          <div style={{paddingBottom: "10px"}}><span style={regularTextStyles}>In the last 3 years, how many driver-related incidents or driver license suspensions,
                    disqualifications
                    or cancellations has this driver had?</span>
            <TooltipTFAF
              title="Driver-related incidents are those that resulted in damage to your car or another person's car or property, whether you caused the incident or not.">
              <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
            </TooltipTFAF>
          </div>

          <div>
            {/*<Form.Group controlId="formIncidents" className="form-group">*/}
            <select
              className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              style={{
                border: '1px #E5E7EB solid',
                boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                borderRadius: 6,
                width: '100%',
                maxWidth: '300px',
                outline: 'none',
                lineHeight: 'inherit',
                fontSize: '1rem', //16px
                fontFamily: 'Lato',
                fontWeight: '400',
                wordWrap: 'break-word',
                height: '40px',
                marginRight: '10px',
                background: 'transparent',
              }}
              defaultValue={getAttributeValue(index, 'incidentCount')}
              required
              name={`driver${index + 1}.incidentCount`}
              onChange={(e) => handleIncidentCount(e, index + 1)}
            >
              <option value="" disabled>Please select</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5+">5+</option>
            </select>
            {/*</Form.Group>*/}
            {errors[`driver${index + 1}.incidentCount`] && (
              <div style={regularErrorStyle}>{errors[`driver${index + 1}.incidentCount`]}</div>
            )}
          </div>
          {/*<div>{props.inputValues.driverList['driver' + (index + 1)].incidentCount}</div>*/}
          {renderIncidentsData(props.inputValues.driverList['driver' + (index + 1)].incidentCount, index + 1)}
        </div>)}
        {props.inputValues.driverLength > 1 && <div style={{color: "red", paddingTop: "30px"}}>-&nbsp;&nbsp;
          <a
            onClick={() => handleRemoveDriver(props.inputValues.driverLength)}
            style={{textDecoration: 'underline', cursor: 'pointer', color: "red"}}>
            Remove driver
          </a>
        </div>}
        {props.inputValues.driverLength < 5 && <div style={{color: '#1851A3', paddingTop: "30px"}}>
          +&nbsp;&nbsp;
          <a onClick={handleAddDriver} style={{textDecoration: 'underline', cursor: 'pointer', color: '#1851A3'}}>
            Add another driver
          </a>
          <TooltipTFAF
            title="Anyone driving the car who is not a listed driver on your policy will incur a higher excess should they be involved in a claimable event.">
            <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
          </TooltipTFAF>
        </div>}
        <div>
          <div style={{paddingBottom: "10px", paddingTop: "30px"}}>
                    <span
                      style={boldTextStyles}>Have you or any member of your household or any other person to be covered by this insurance:</span>
          </div>
          <ul style={{...regularTextStyles, margin: 0, paddingBottom: 0}}>
            <li>Had any insurance declined, cancelled, renewal refused, terms or conditions imposed or any
              claim
              declined?
            </li>
            <li>Been engaged in any criminal activity or had any criminal convictions, acquittals, or have
              any
              criminal prosecutions pending?
            </li>
          </ul>
          <div style={{fontStyle: "italic", paddingLeft: "30px"}}><span style={regularTextStyles}>The information sought by this question is subject to the rights set out in the Criminal
                    Records
                    (Clean Slate) Act 2004.</span>
          </div>
          <div style={{paddingTop: "10px", paddingBottom: "30px", display: "flex", alignItems: "center", gap: "100px"}}>
            <Form.Check
              type="radio"
              label="Yes"
              style={regularTextStyles}
              className="custom-radio"
              id="criminalRecordYes"
              checked={props.inputValues.isCriminalRecord === "YES"}
              onChange={(e) => {
                props.handleChangeValue("isCriminalRecord", "YES");
                setContinueOfflinePopupShow(true);
              }}
            />
            <Form.Check
              type="radio"
              label="No"
              style={regularTextStyles}
              className="custom-radio"
              id="criminalRecordNo"
              checked={props.inputValues.isCriminalRecord === "NO"}
              onChange={(e) => {
                props.handleChangeValue("isCriminalRecord", "NO");
                setContinueOfflinePopupShow(false);
              }}
            />
          </div>
          {errors.isCriminalRecord && <div style={regularErrorStyle}>{errors.isCriminalRecord}</div>}
        </div>
      </div>
      <ContinueOfflinePopupTFAF1
        parentContinueOfflinePopupShow={continueOfflinePopupShow}
        setParentContinueOfflinePopupShow={setContinueOfflinePopupShow}
        parentModificationText={props.inputValues.modification}
      />
      <div style={{paddingBottom: "150px"}}>
        <p
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: "center",
            paddingTop: '32px'
          }}>
          <button
            className="float-end"
            onClick={() => props.prevStep()}
            style={{
              color: '#1851A3',
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              background: 'white',
              border: '1px #1851A3 solid',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              wordWrap: 'break-word',
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: 6,
              width: "100%",
              maxWidth: "200px"
            }}
          >
            Back
          </button>
          <button
            className="float-end"
            style={{
              color: "white",
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              width: "100%",
              maxWidth: "200px",
              background: props.inputValues.isCriminalRecord === 'YES' || isSubmitting ? '#B0C4DE' : '#1851A3',
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: 6,
              overflow: 'hidden',
              border: '1px white solid',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              cursor: !isSubmitting ? 'pointer' : 'progress',
              opacity: 1
            }}
            onClick={handleNextButtonClick}
            disabled={props.inputValues.isCriminalRecord === 'YES' || isSubmitting}
          >
            Next
          </button>
        </p>
      </div>
    </div>
  </>;
}

export default DriverDetails;
